<template>
  <div id="list">
    <vue-good-table
      ref="orders"
      :columns="columns"
      :rows="orders"
      :selectOptions="{enabled: true, selectOnCheckboxOnly: true}"
      :search-options="{
        enabled: true,
        trigger: 'enter',
        skipDiacritics: true,
        placeholder: 'Search Sepcial Orders',
      }"
      max-height="calc(100vh - 100px)"
      :fixed-header="true"
    >
      <template slot="table-actions">
        <a
          target="_blank"
          class="btn btn-primary btn-sm mr-2"
          :href="palletBreakdownUrl()">
          Pallet Breakdown
        </a>
        <a
          target="_blank"
          class="btn btn-primary btn-sm mr-1"
          :href="palletLabelsUrl()">
          Pallet Labels
        </a>
      </template>
      <template slot="selected-row-actions">
        SET:
        <button class="btn btn-primary btn-sm" @click="update_status(2)">Pending</button>
        <button class="btn btn-primary btn-sm" @click="update_status(18)">Scheduled</button>
        <button class="btn btn-primary btn-sm" @click="update_status(16)">At Whse</button>
        <button class="btn btn-primary btn-sm" @click="update_status(21)">On Truck</button>
        <button class="btn btn-primary btn-sm" @click="update_status(10)">Departed</button>
        <button class="btn btn-primary btn-sm" @click="update_status(11)">Delviered</button>
      </template>


      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'id'">
          <router-link :to="'/special/' + props.row.id">SO-{{props.row.id}}</router-link>
        </span>
        <span v-else-if="props.column.field == 'pallets'">
          <span v-for="pallet in props.row.pallets" :key="pallet.id"
            class="badge badge-pill badge-dark py-1 px-2">
            {{ pallet.name }}
          </span>
        </span>        
        <span v-else-if="props.column.field == 'status.name'">
          <span class="badge badge-pill badge-dark py-1 px-2" :style="`background: ${props.row.status.color}`">
            {{ props.row.status.name }}
          </span>
        </span>
        <span v-else-if="props.column.field == 'links'">
          <a target="_blank" :href="labelsUrl(props.row.id)">Labels</a> |
          <a target="_blank" :href="bolUrl(props.row.id)">BOL</a>
        </span>
        <span v-else>
          {{props.formattedRow[props.column.field]}}
        </span>
      </template>

    </vue-good-table>    
  </div>

</template>

<script>

  import api from '@/api'
  import n from '@/libs/notifications'
  import { VueGoodTable } from 'vue-good-table'

  export default {
    name: 'orders-list',

    props: ['orders', 'selectedStatus', 'statuses'],

    components: {
      VueGoodTable
    },

    data() {
      return {
        columns: [
          {
            label: 'ID',
            type: 'number',
            html: true,
            field: 'id'
          },
          {
            label: 'Status',
            field: 'status.name'
          },          
          {
            label: 'Client',
            field: 'client.nickname',
          },
          {
            label: 'PO',
            field: 'po_number',
          },
          {
            label: 'Order #',
            field: 'client_order_number',
          },
          {
            label: 'Pickup',
            type: 'number',
            field: 'origin.name',
          },          
          {
            label: 'Destination',
            field: 'store.id',
            formatFn: v => `Store ${v.toString().padStart(4, '0')}`
          },
          {
            label: 'Cases',
            type: 'number',
            field: 'total_qty'
          },
          {
            label: 'Pallets',
            field: 'pallets',
          },
          {
            label: 'Region',
            field: 'region.name',
          },
          {
            label: '',
            html: true,
            field: 'links'
          }
        ]        
      }
    },

    watch: {
    },

    methods: {
      open_order(id) {
        alert(id)
      },

      update_status(new_status_id) {
        const orders = this.$refs.orders.selectedRows
        api.post(`/special-orders/batch-status-update/${new_status_id}`, { orders }).then(() => {
          this.$emit('orders-updated')
          n.success(`${orders.length} status(es) updated.`)
        })
      },

      labelsUrl(id) {
        return `${api.baseUrl}/special-orders/${id}/plcb-labels`
      },

      bolUrl(id) {
        return `${api.baseUrl}/special-orders/${id}/bol`
      },

      palletBreakdownUrl() {
        return `${api.baseUrl}/special-orders/pallet-breakdown`
      },
      
      palletLabelsUrl() {
        return `${api.baseUrl}/special-orders/pallet-labels`
      },

    }
  }
</script>

<style scoped>

#list {
  height: calc(100vh - 48px);
}

</style>